import {useState} from 'react';
import {motion,useReducedMotion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import {incrementClicks} from '../services/siteContentService';

const {
  FiArrowUpRight,
  FiHeadphones,
  FiMic,
  FiMonitor,
  FiPackage,
  FiVideo
}=FiIcons;

const categoryIcons={
  Audio: FiHeadphones,
  Cameras: FiVideo,
  Creator: FiMic,
  Desk: FiMonitor
};

function getImageShape(image) {
  const ratio=image.naturalWidth / image.naturalHeight;

  if (ratio > 1.15) return 'landscape';
  if (ratio < 0.87) return 'portrait';
  return 'square';
}

function ProductVisual({item,ProductIcon}) {
  const [shape,setShape]=useState('square');
  const [imageFailed,setImageFailed]=useState(false);

  const showImage=item.image_url && !imageFailed;

  return (
    <span className={`amazon-find-visual is-${shape}`}>
      {showImage ? (
        <img
          src={item.image_url}
          alt={item.title || 'Amazon product'}
          loading="lazy"
          decoding="async"
          onLoad={(event)=> setShape(getImageShape(event.currentTarget))}
          onError={()=> setImageFailed(true)}
        />
      ) : (
        <SafeIcon icon={ProductIcon} />
      )}
    </span>
  );
}

export default function AmazonFindCard({item,index=0}) {
  const reduceMotion=useReducedMotion();
  const ProductIcon=categoryIcons[item.category] || FiPackage;

  const trackClick=()=> {
    if (!String(item.id).startsWith('fallback')) {
      incrementClicks('amazonFinds',item).catch(()=> {});
    }
  };

  return (
    <motion.a
      href={item.url}
      target="_blank"
      rel="sponsored noreferrer"
      className="amazon-find-card"
      onClick={trackClick}
      initial={reduceMotion ? false : {opacity: 0,y: 8}}
      animate={{opacity: 1,y: 0}}
      transition={{
        duration: 0.28,
        delay: reduceMotion ? 0 : Math.min(index * 0.04,0.16)
      }}
      whileTap={reduceMotion ? undefined : {scale: 0.98}}
    >
      <ProductVisual item={item} ProductIcon={ProductIcon} />

      <span className="amazon-find-copy">
        <span className="amazon-find-meta">
          {item.category || 'Amazon find'}
        </span>
        <strong>{item.title}</strong>
        <small>{item.description}</small>
        {item.price_label && (
          <span className="amazon-find-price">{item.price_label}</span>
        )}
      </span>

      <span className="amazon-find-arrow">
        <SafeIcon icon={FiArrowUpRight} />
      </span>
    </motion.a>
  );
}